import ApiService from "../ApiService";

const providerService = {
    getProviders() {
        return ApiService.get(`/provider`);
    },

    createProvider(formData) {
        let data = JSON.stringify(formData);
        return ApiService.post("api/enter-order/", formData);
    },
    createProviders(formData) {
        return ApiService.post("/provider/", formData);
    },
    updateProviders(id, formData) {
        return ApiService.post(`/provider/update?id=${id}`, formData);
    },
    deleteProviders(formData) {
        return ApiService.post(`/provider/remove/`, formData);
    }
};

export default providerService;
